import LoadingStatus from 'enums/loadingStatus';

const fetchStatus = LoadingStatus.Idle;
const title = document.title;
const metaDescription = document.querySelector('meta[name="description"]')?.content;
const metaRobots = document.querySelector('meta[name="robots"]')?.content;
const canonical = document.querySelector('link[rel="canonical"]')?.href;
const heading1 = document.querySelector('[data-heading1]')?.innerText;
const heading2 = document.querySelector('[data-heading2]')?.innerText;
const footer = document.querySelector('[data-footer-content]')?.innerHTML;
const marketOverviewTitle = document.querySelector('[data-state-search-market-overview-title]')?.innerText;
const marketOverviewContent = document.querySelector('[data-state-search-market-overview-content]')?.innerText;
const marketOverviewStats = null;
const specialCommunities = document.querySelector('[data-state-search-special-communities-content]')?.innerHTML;
const faqTitle = document.querySelector('[data-state-search-faq-title]')?.innerText;
const faqContent = document.querySelector('[data-state-search-faq-content]')?.innerHTML;
const guidesTitle = document.querySelector('[data-state-search-guides-title]')?.innerText;
const guidesContent = document.querySelector('[data-state-search-guides-content]')?.innerHTML;
const articleTitle = document.querySelector('[data-state-search-article-title]')?.innerText;
const articleContent = document.querySelector('[data-state-search-article-content]')?.innerHTML;
const topMarketsTitle = document.querySelector('[data-state-search-top-markets-title]')?.innerText;

export default {
    fetchStatus,
    title,
    metaDescription,
    metaRobots,
    canonical,
    heading1,
    heading2,
    footer,
    marketOverviewTitle,
    marketOverviewContent,
    marketOverviewStats,
    specialCommunities,
    faqTitle,
    faqContent,
    guidesTitle,
    guidesContent,
    articleTitle,
    articleContent,
    topMarketsTitle
};